module.exports = __webpack_public_path__ + "static/media/Logo__Pinterest.70b81890.svg";